import React, { ReactElement } from "react";
import styles from "./styles.module.scss";
import Header from "@components/shared/header";
import MainBanner from "@components/medicalsoftwarequotes/mainBanner";
import MainImage from "@components/medicalsoftwarequotes/mainImage";
import colors from "@styles/variables/medicalsoftwarequotesVariables.module.scss";
import MedicalSoftwareLogo from "../logo";
import { useDomainContext } from "@hooks/useDomainContext";
import { useRouter } from "next/router";
import { finalShowForm } from "@lib/sharedUtils";
import TextBlockOffer from "@components/shared/textBlockOffer/TextBlockOffer";

export default function TopSection(): ReactElement {
    const router = useRouter();
    const { domain } = useDomainContext();
    const isFormDisplayed = finalShowForm(
        router.query.sl as string,
        domain.showForm,
        domain.defaultOffers,
    );
    return (
        <div className={`${styles["topSection"]}`}>
            {isFormDisplayed ? (
                <div className={` ${styles["mxWrapper"]}`}>
                    <Header
                        slogan="the best medical software quotes"
                        textColor={colors.offerCallNumber}
                    >
                        <MedicalSoftwareLogo />
                    </Header>

                    <main className={`px-4vw lg:px-4`}>
                        <div
                            className={`flex flex-col md:flex-row items-center justify-between`}
                        >
                            <MainBanner />
                            <MainImage />
                        </div>
                    </main>
                </div>
            ) : (
                <div>
                    <Header
                        slogan="the best medical software quotes"
                        textColor={colors.offerCallNumber}
                    >
                        <MedicalSoftwareLogo />
                    </Header>
                    <TextBlockOffer />
                </div>
            )}
        </div>
    );
}
